import { SvgIcon, SvgIconProps } from "@mui/material";

export const OnsiteInjectionsIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "44px", height: props.height ?? "44px" }}
    >
      <svg
        {...props}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1400_657"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="44"
          height="44"
        >
          <rect width="44" height="44" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1400_657)">
          <path
            d="M15.8582 37.5837L4.58317 26.3087C4.27761 26.0031 4.04845 25.667 3.89567 25.3003C3.74289 24.9337 3.6665 24.5517 3.6665 24.1545C3.6665 23.7573 3.74289 23.3753 3.89567 23.0087C4.04845 22.642 4.27761 22.3059 4.58317 22.0003L15.1248 11.5045L10.2665 6.64616L13.1082 3.66699L31.4415 22.0003C31.7471 22.3059 31.9686 22.642 32.1061 23.0087C32.2436 23.3753 32.3123 23.7573 32.3123 24.1545C32.3123 24.5517 32.2436 24.9337 32.1061 25.3003C31.9686 25.667 31.7471 26.0031 31.4415 26.3087L20.1665 37.5837C19.8609 37.8892 19.5248 38.1184 19.1582 38.2712C18.7915 38.4239 18.4096 38.5003 18.0123 38.5003C17.6151 38.5003 17.2332 38.4239 16.8665 38.2712C16.4998 38.1184 16.1637 37.8892 15.8582 37.5837ZM18.0123 14.392L8.204 24.2003H27.8207L18.0123 14.392ZM36.2998 38.5003C35.1998 38.5003 34.2679 38.1107 33.504 37.3316C32.7401 36.5524 32.3582 35.5975 32.3582 34.467C32.3582 33.642 32.5644 32.8628 32.9769 32.1295C33.3894 31.3962 33.8554 30.6781 34.3748 29.9753L36.2998 27.5003L38.3165 29.9753C38.8054 30.6781 39.2637 31.3962 39.6915 32.1295C40.1193 32.8628 40.3332 33.642 40.3332 34.467C40.3332 35.5975 39.9359 36.5524 39.1415 37.3316C38.3471 38.1107 37.3998 38.5003 36.2998 38.5003Z"
            fill={props.fill ?? "#494C50"}
          />
        </g>
        <mask
          id="mask1_1400_657"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="25"
          y="1"
          width="19"
          height="20"
        >
          <rect
            x="25.6665"
            y="1.83301"
            width="18.3333"
            height="18.3333"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask1_1400_657)">
          <path
            d="M32.7317 18.6352L32.4261 16.1908C32.2606 16.1271 32.1046 16.0507 31.9582 15.9616C31.8118 15.8725 31.6686 15.777 31.5285 15.6751L29.256 16.63L27.1553 13.0015L29.1223 11.5119C29.1096 11.4228 29.1032 11.3369 29.1032 11.2541V10.7385C29.1032 10.6557 29.1096 10.5698 29.1223 10.4807L27.1553 8.9911L29.256 5.36263L31.5285 6.31749C31.6686 6.21564 31.815 6.12015 31.9678 6.03103C32.1206 5.94191 32.2733 5.86552 32.4261 5.80187L32.7317 3.35742H36.933L37.2386 5.80187C37.4041 5.86552 37.5601 5.94191 37.7065 6.03103C37.8529 6.12015 37.9961 6.21564 38.1362 6.31749L40.4087 5.36263L42.5094 8.9911L40.5424 10.4807C40.5552 10.5698 40.5615 10.6557 40.5615 10.7385V11.2541C40.5615 11.3369 40.5488 11.4228 40.5233 11.5119L42.4903 13.0015L40.3896 16.63L38.1362 15.6751C37.9961 15.777 37.8497 15.8725 37.6969 15.9616C37.5442 16.0507 37.3914 16.1271 37.2386 16.1908L36.933 18.6352H32.7317ZM34.8706 13.6699C35.609 13.6699 36.2392 13.4089 36.7612 12.8869C37.2832 12.3649 37.5442 11.7347 37.5442 10.9963C37.5442 10.2579 37.2832 9.62768 36.7612 9.10569C36.2392 8.5837 35.609 8.3227 34.8706 8.3227C34.1194 8.3227 33.486 8.5837 32.9704 9.10569C32.4548 9.62768 32.1969 10.2579 32.1969 10.9963C32.1969 11.7347 32.4548 12.3649 32.9704 12.8869C33.486 13.4089 34.1194 13.6699 34.8706 13.6699Z"
            fill={props.fill ?? "#494C50"}
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
